import { alpha } from "@mui/material/styles";

export const SEO_COLORS = {
  pass: "#2e7d32",
  warn: "#f57c00",
  fail: "#d32f2f",
  primary: "#1976d2",
  deepOrange: "#e65100",
  darkRed: "#b71c1c",
};

// Brand palette from lts-landing — used for decorative chrome only
export const BRAND = {
  crimson:    "#dc2626",
  amber:      "#f59e0b",
  cyan:       "#06b6d4",
  blue:       "#3b82f6",
  purple:     "#a855f7",
  deepPurple: "#7c3aed",
  gradient:        "linear-gradient(135deg, #dc2626, #f59e0b)",   // brand accent (teaser, badge)
  gradientFlow:    "linear-gradient(135deg, #06b6d4, #a855f7)",   // overall ring & accent bars
  gradientTech:    "linear-gradient(135deg, #06b6d4, #3b82f6)",   // SEO Technical ring
  gradientContent: "linear-gradient(135deg, #7c3aed, #a855f7)",   // Content ring
  gradientGeo:     "linear-gradient(135deg, #3b82f6, #a855f7)",   // GEO ring
};

// Per-pillar category colors — same as before, with gradient info added
export const CATEGORY_COLORS = {
  "SEO Technical": {
    color:         "#1976d2",
    bg:            alpha("#1976d2", 0.1),
    gradient:      BRAND.gradientTech,
    gradientStart: "#06b6d4",
    gradientEnd:   "#3b82f6",
  },
  "Content": {
    color:         "#7b1fa2",
    bg:            alpha("#7b1fa2", 0.1),
    gradient:      BRAND.gradientContent,
    gradientStart: "#7c3aed",
    gradientEnd:   "#a855f7",
  },
  "GEO": {
    color:         "#00796b",
    bg:            alpha("#00796b", 0.1),
    gradient:      BRAND.gradientGeo,
    gradientStart: "#3b82f6",
    gradientEnd:   "#a855f7",
  },
};

export const STATUS_COLORS = {
  pass: { color: SEO_COLORS.pass, bg: alpha(SEO_COLORS.pass, 0.08) },
  warn: { color: SEO_COLORS.warn, bg: alpha(SEO_COLORS.warn, 0.08) },
  fail: { color: SEO_COLORS.fail, bg: alpha(SEO_COLORS.fail, 0.08) },
};

export const PRIORITY_COLORS = {
  HIGH:   { color: SEO_COLORS.fail,      bg: alpha(SEO_COLORS.fail,      0.08), label: "High Impact" },
  MEDIUM: { color: SEO_COLORS.deepOrange, bg: alpha(SEO_COLORS.deepOrange, 0.08), label: "Medium Impact" },
  LOW:    { color: SEO_COLORS.primary,    bg: alpha(SEO_COLORS.primary,    0.08), label: "Low Impact" },
};

export const GRADE_COLORS = {
  A: SEO_COLORS.pass,
  B: SEO_COLORS.primary,
  C: SEO_COLORS.warn,
  D: SEO_COLORS.fail,
  F: SEO_COLORS.darkRed,
};


// Checks visible in the article body — fixed by the prose rewriter.
export const REWRITER_CONTENT_CHECKS = new Set([
  "Answer-First Structure",
  "Entity Definitions",
  "Attributed Statistics",
  "Source Citations",
  "Inline Expert Quotes",
  "Statistics & Data Density",
  "Citable Data Sentences",
  "Content Comprehensiveness",
  "Question-Format Headings",
  "TL;DR / Key Takeaways",
  "Wikipedia / Wikidata Presence",
]);

// Checks invisible to readers — schema + meta fixed by assembly.
export const REWRITER_TECHNICAL_CHECKS = new Set([
  "Article Schema",
  "Speakable Schema",
  "FAQ Schema",
  "Author Attribution",
  "Knowledge Panel Signals",
  "Image Alt Text Coverage",
  "Topic in Meta Description",
  "Organization Schema",
  "BreadcrumbList Schema",
  "knowsAbout Property",
]);

// Union — all checks the rewriter addresses (used for impact points sum)
export const REWRITER_FIXABLE_CHECKS = new Set([
  ...REWRITER_CONTENT_CHECKS,
  ...REWRITER_TECHNICAL_CHECKS,
]);

// Backward-compat alias
export const GEO_CONTENT_CHECKS = REWRITER_FIXABLE_CHECKS;

export function scoreColor(score) {
  if (score >= 80) return SEO_COLORS.pass;
  if (score >= 60) return SEO_COLORS.warn;
  if (score >= 40) return SEO_COLORS.deepOrange;
  return SEO_COLORS.fail;
}
